import React from 'react'

function CharCounterHint({ value, softLimit, helperText }) {
  const length = typeof value === 'string' ? value.length : 0
  const over = softLimit != null && length > softLimit

  return (
    <div className="CharCounterHint" style={{ marginTop: 4, fontSize: 12, color: over ? '#c0392b' : '#666' }}>
      {helperText ? <div>{helperText}</div> : null}
      {softLimit != null ? (
        <div>
          {length} / ~{softLimit}
          {over ? ' (рекомендовано коротше)' : ''}
        </div>
      ) : null}
    </div>
  )
}

export default CharCounterHint
